import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { SessionService, ModalService, AuthService, AdminService, DialogService } from '../../../services';
import { BeasleyService } from '../../../services/beasley/beasley.service';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { ModalComponent } from '../../modal/modal.component';

@Component({
    selector: 'sn-bfp-header',
    templateUrl: './bfp-header.component.html',
    styleUrls: ['./bfp-header.component.css', '../beasley.component.css']
})
export class BfpHeaderComponent implements OnInit {

    customer_name:string = "";
    customer_company:string = "";
    searchText:string = "";

    constructor(
        private router: Router,
        private dialogService: DialogService,
        private adminService: AdminService,
        public ngbModal: NgbModal,
        public authService: AuthService,
        public ngbActiveModal: NgbActiveModal,
        public sessionService: SessionService,
        public modalService: ModalService,
        public beasleyService: BeasleyService
    ) { }

    ngOnInit() {
        this.authService.currentUser.subscribe(
        user => {
                if (user) {
                    // HACK: to get around User type checking to access undefined properties
                    var customer_related_item = user['customer_related_item'];
                    if (customer_related_item && customer_related_item) {
                        this.customer_name = customer_related_item.firstname + ' ' + customer_related_item.lastname;
                        this.customer_company = customer_related_item.company_name;
                    }
            }
        }      
        )
    }

    createNewClaim() {
        this.modalService.openContent(
            ModalComponent,
            { view: this.beasleyService.view_bfp_form_claim_request, data: { view_ID: 0 } },
            { size: "lg", backdrop: 'static', keyboard: false }
        ).result.then((result) => {
                this.beasleyService.setNewClaim(result);
                this.sessionService.log('beasley_claim_request submitted');
            }, (reason) => {
                this.sessionService.log('Form Closed');
        })
    }

    createNewChat() {
        this.modalService.openContent(
            ModalComponent,
            { view: this.beasleyService.view_bfp_form_chat_message, data: { view_ID: 0 } },
            { backdrop: 'static', keyboard: false }
        ).result.then((result) => {
                //this.beasleyService.setNewClaim(result);
                this.sessionService.log('beasley_chat_message submitted');
            }, (reason) => {
                this.sessionService.log('Form Closed');
        })
    }

    search() {
        this.beasleyService.setSearchText(this.searchText);
    }

    changePassword() {
        this.adminService.changePassword('dcc@salesnow.com').subscribe(
            result => { 
                this.modalService.openContent(
                    DialogComponent,
                    { dlgType: this.dialogService.dlg_type_password },
                    { backdrop: 'static', keyboard: false }
                ).result.then(
                    (result) => { },
                    (reason) => { }
                );        
            },
            err => { console.log(err);}
        );
    }

    logOff() {
        this.authService.logoff();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/beasley/bfp-header/bfp-header.component.ts